function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import styled from 'styled-components';
import Tag from '../Tag';
import { TagList } from '../Tag/style';
export var customStyles = {
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: 'none'
    };
  },
  control: function control(provided, _ref) {
    var isOpen = _ref.isOpen,
      isFocused = _ref.isFocused,
      selectProps = _ref.selectProps;
    var borderColor = selectProps.themeContext.colors.border.gray;
    if (isOpen || isFocused) {
      borderColor = selectProps.themeContext.colors.border.primary;
    }
    if (selectProps.error) {
      borderColor = selectProps.themeContext.colors.border.alert;
    }
    return _objectSpread(_objectSpread({}, provided), {}, {
      boxShadow: 'none',
      borderRadius: 0,
      borderColor: borderColor,
      '&:hover': {
        borderColor: borderColor
      }
    });
  },
  menuList: function menuList(provided, _ref2) {
    var selectProps = _ref2.selectProps;
    return _objectSpread(_objectSpread({}, provided), {}, {
      border: "1px solid ".concat(selectProps.themeContext.colors.border.primary)
    });
  },
  option: function option(provided, _ref3) {
    var isFocused = _ref3.isFocused,
      selectProps = _ref3.selectProps;
    return _objectSpread(_objectSpread({}, provided), {}, {
      display: 'flex',
      justifyContent: 'space-between',
      color: selectProps.themeContext.colors.text.primary,
      backgroundColor: isFocused ? selectProps.themeContext.colors.background.tertiary : 'none',
      '&:hover': {
        backgroundColor: selectProps.themeContext.colors.background.tertiary
      }
    });
  }
};
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-8l34ut-0"
})(["font-family:", ";align-items:left;display:flex;flex-direction:column;padding:", ";min-width:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.spacing.sp4, " ").concat(theme.spacing.sp0);
}, function (props) {
  return props.selectWidth ? props.selectWidth : '150px';
});
export var StyledSelectLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "style__StyledSelectLabel",
  componentId: "sc-8l34ut-1"
})(["font-size:", ";margin-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.fontSize.ft14;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing.sp4;
});
export var SelectWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__SelectWrapper",
  componentId: "sc-8l34ut-2"
})(["cursor:pointer;width:100%;"]);
export var ErrorMessage = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__ErrorMessage",
  componentId: "sc-8l34ut-3"
})(["color:", ";font-family:", ";font-size:", ";margin-top:", ";display:block;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.text.alert;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fonts.fontSize.ft14;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.spacing.sp4;
});
export var TagWrapper = /*#__PURE__*/styled(Tag).withConfig({
  displayName: "style__TagWrapper",
  componentId: "sc-8l34ut-4"
})(["margin:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacing.sp4;
});
export var TagListWrapper = /*#__PURE__*/styled(TagList).withConfig({
  displayName: "style__TagListWrapper",
  componentId: "sc-8l34ut-5"
})(["flex-wrap:wrap;margin-top:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing.sp2;
});
export var StyledRemoveIcon = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__StyledRemoveIcon",
  componentId: "sc-8l34ut-6"
})(["display:flex;margin-left:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacing.sp8;
});